import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { AtendimentoPadraoForm } from '../components/AtendimentoPadraoForm';
import * as service from './atendimentos_identificacao_civil.service';
export var AtendimentosIdentificacaoCivilEditar = function () {
    return (_jsx(AtendimentoPadraoForm, { pagina: PAGINAS.ATENDIMENTOS_IDENTIFICACAO_CIVIL, pagina_chave: FUNCIONALIDADES.ATENDIMENTOS_IDENTIFICACAO_CIVIL, rota: ROUTES.ATENDIMENTOS_IDENTIFICACAO_CIVIL, services: service, camposIdentificacaoCivil: true }));
};
export default AtendimentosIdentificacaoCivilEditar;
